<template>
  <div>
    <b-modal
      :visible="value"
      :title="`Sửa KPI ${isPayment ? 'thanh toán' : 'bán hàng'}`"
      @hide="closeModal"
      ignore-enforce-focus-selector="input"
    >
      <!-- PAYMENT -->
      <ValidationObserver v-if="isPayment" ref="formAdd">
        <form @submit.prevent="">
          <ValidationProvider rules="" vid="serial" name="Serial thiết bị">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Serial thiết bị</label>
              <div class="col-sm-9">
                <b-form-input v-model="formData.serial" disabled></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="contractCode" name="Mã hợp đồng">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Mã hợp đồng</label>
              <div class="col-sm-9">
                <b-form-input disabled v-model="formData.contractCode"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="appendixCode" name="Mã phụ lục">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Mã phụ lục</label>
              <div class="col-sm-9">
                <b-form-input disabled v-model="formData.appendixCode"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="merchantEmail" name="Email MC">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Email MC</label>
              <div class="col-sm-9">
                <b-form-input disabled v-model="formData.merchantEmail"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="transactionCode" name="Mã giao dịch">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Mã giao dịch</label>
              <div class="col-sm-9">
                <b-form-input disabled v-model="formData.transactionCode"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="month" name="Tháng tính KPI">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Tháng tính KPI<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <SelectMonth v-model="formData.month" placeholder="Tháng tính KPI"></SelectMonth>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="kpi" name="Số KPI">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Số KPI<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <b-form-input v-model="formData.kpi"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="emailSale" name="Email CVKD">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Email CVKD<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <Select2
                  v-model="formData.emailSale"
                  :options="optionsListUserByEmail"
                  placeholder="Email CVKD"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="note" name="Ghi Chú">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Ghi Chú</label>
              <div class="col-sm-9">
                <textarea class="form-control" v-model.trim="formData.note"></textarea>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
        </form>
      </ValidationObserver>

      <!-- SELL -->
      <ValidationObserver v-if="!isPayment" ref="formAdd">
        <form @submit.prevent="">
          <ValidationProvider rules="" vid="merchantEmail" name="Email MC">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Email MC</label>
              <div class="col-sm-9">
                <b-form-input disabled v-model="formData.merchantEmail"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="contractCode" name="Mã hợp đồng">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Mã hợp đồng</label>
              <div class="col-sm-9">
                <b-form-input disabled v-model="formData.contractCode"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="appendixCode" name="Mã phụ lục">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Mã phụ lục</label>
              <div class="col-sm-9">
                <b-form-input disabled v-model="formData.appendixCode"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="service" name="Dịch vụ">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Dịch vụ</label>
              <div class="col-sm-9">
                <b-form-input disabled v-model="formData.service"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="duration" name="Thời hạn">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Thời hạn</label>
              <div class="col-sm-9">
                <b-form-input disabled v-model="formData.duration"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="serial" name="Serial phần cứng">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Serial phần cứng</label>
              <div class="col-sm-9">
                <b-form-input disabled v-model="formData.serial"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="" vid="transactionCode" name="Mã giao dịch">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Mã giao dịch</label>
              <div class="col-sm-9">
                <b-form-input disabled v-model="formData.transactionCode"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="month" name="Tháng tính KPI">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Tháng tính KPI<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <SelectMonth v-model="formData.month" placeholder="Tháng tính KPI"></SelectMonth>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="kpi" name="Số KPI">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Số KPI<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <b-form-input v-model="formData.kpi"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="emailSale" name="Email CVKD">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >CVKD<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <Select2
                  v-model="formData.emailSale"
                  :options="optionsListUserByEmail"
                  placeholder="Email CVKD"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="note" name="Ghi Chú">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label">Ghi Chú</label>
              <div class="col-sm-9">
                <textarea class="form-control" v-model.trim="formData.note"></textarea>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
        </form>
      </ValidationObserver>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button variant="danger" @click="closeModal" class="mr-2"> Huỷ </b-button>
          <b-button variant="primary" @click="submit"> Sửa </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import { getListUserFn, getListUserFnByEmail } from '../kpiRecordMx'
  import SelectMonth from './SelectMonth.vue'
  export default {
    components: { SelectMonth },
    props: ['value', 'dataEdit', 'serviceType'],
    data() {
      return {
        Config,
        show: true,
        formData: {
          kpi: '',
        },
        optionsListUserByEmail: [],
        optionsListUser: [],
      }
    },
    watch: {
      value: {
        immediate: true,
        deep: true,
        handler(val) {
          console.log(this.serviceType)
          if (val) {
            this.getListUser()
            this.formData = null
            this.formData = { ...this.dataEdit }
          }
        },
      },
    },
    computed: {
      isPayment() {
        return this.serviceType === 'PAYMENT'
      },
    },
    methods: {
      closeModal() {
        this.$emit('input', false)
      },
      async submit() {
        const isSuccess = await this.$refs.formAdd.validate()
        if (!isSuccess) return
        const findedNewUser = this.optionsListUser.find(e => e.userName === this.formData.emailSale)
        if (!findedNewUser?.id) {
          this.showFailMx('Không tìm thấy idSale')
          return
        }
        this.formData.idSale = findedNewUser.id
        this.formData.kpi = Number(this.formData.kpi)
        this.$emit('submit', { data: { ...this.formData }, serviceType: this.serviceType })
      },
      async getListUser() {
        this.optionsListUserByEmail = await getListUserFnByEmail()
        this.optionsListUser = await getListUserFn()
      },
    },
  }
</script>

<style></style>
